export default __webpack_public_path__ + "static/media/06_follow_get_in_front.ce31b324.jpg";